var _effectorFileName = "/builds/gmini/front-ui-kit/src/DefaultSnackbarProvider.tsx";
import React from 'react';
import { SnackbarProvider } from 'notistack';
import { IconButton } from '@mui/material';
import { Cancel } from '@mui/icons-material';
import { jsx as _jsx } from "react/jsx-runtime";
export const DefaultSnackbarProvider = /*#__PURE__*/React.memo(props => {
  const notistackRef = React.useRef(null);

  const onClickDismiss = key => () => {
    var _notistackRef$current;

    (_notistackRef$current = notistackRef.current) === null || _notistackRef$current === void 0 ? void 0 : _notistackRef$current.closeSnackbar(key);
  };

  return /*#__PURE__*/_jsx(SnackbarProvider, {
    ref: notistackRef,
    maxSnack: 3,
    hideIconVariant: true,
    anchorOrigin: {
      horizontal: 'center',
      vertical: 'top'
    },
    preventDuplicate: true,
    autoHideDuration: 5000,
    action: key => /*#__PURE__*/_jsx(IconButton, {
      "data-test-id": "closeError",
      size: "small",
      onClick: onClickDismiss(key),
      children: /*#__PURE__*/_jsx(Cancel, {})
    }),
    ...props
  });
});
DefaultSnackbarProvider.displayName = 'DefaultSnackbarProvider';